import {
  SystemUserCreateInterface,
  SystemUserEditInterface, SystemUserInterface,
  SystemUserRepositoryInterface,
} from '@/services/SystemUsers/interfaces';
import { AxiosInstance } from 'axios';

export default class SystemUserRepository implements SystemUserRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async createSystemUser(data: SystemUserCreateInterface): Promise<void> {
    await this.axios.post('/system-user/system-users', data);
  }

  public async deleteSystemUser(id: number): Promise<void> {
    await this.axios.delete(`/system-user/system-users/${id}`);
  }

  public async editSystemUser(id: number, data: SystemUserEditInterface): Promise<void> {
    await this.axios.patch(`/system-user/system-users/${id}`, data);
  }

  public async findSystemUsers(page: number, search?: string, itemsPerPage?: number): Promise<[SystemUserInterface[], number]> {
    const params = new URLSearchParams();
    params.set('page', String(page));
    if (itemsPerPage && itemsPerPage > 0) {
      params.set('itemsPerPage', String(itemsPerPage));
    }
    if (search) {
      params.set('search', search);
    }
    const response = await this.axios.get(`/system-user/system-users?${params.toString()}`);

    return response.data;
  }

  public async findSystemUserById(systemUserId: number): Promise<SystemUserInterface> {
    const response = await this.axios.get(`/system-user/system-users/${systemUserId}`);

    return response.data;
  }

  public async findSystemUsersByIds(page: number, ids: number[]): Promise<[SystemUserInterface[], number]> {
    if (!ids.length) {
      return [[], 0];
    }

    let url = `/system-user/system-users?page=${page}&search[]=`;
    url = `${url}${ids.join('&search[]=')}`;

    const response = await this.axios.get(url);

    return response.data;
  }

  public async deleteLog(id: number): Promise<void> {
    await this.axios.delete(`/system-user/logs/${id}`);
  }

  public async changePlan(id: number, planId: number): Promise<void> {
    await this.axios.patch(`/system-user/system-users/${id}/plan`, { planId });
  }

  public async syncQuotas(serverId: string): Promise<void> {
    await this.axios.patch(`/system-user/system-users/servers/${serverId}/quotas`);
  }
}
